import React from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

interface ZoomableImageProps {
  src: string;
  alt?: string;
  className?: string;
  onError?: React.ReactEventHandler<HTMLImageElement>;
}

export const ZoomableImage: React.FC<ZoomableImageProps> = ({ src, alt, className, onError }) => {
  return (
    <TransformWrapper
      wheel={{ step: 0.2 }}
      doubleClick={{ mode: 'reset' }}
      pinch={{ step: 5 }}
      limitToBounds={true}
      centerOnInit={true}
    >
      <TransformComponent
        wrapperStyle={{ width: '100%', height: '100%' }}
        contentStyle={{ width: '100%', height: '100%' }}
      >
        <img src={src} alt={alt} className={className} onError={onError} />
      </TransformComponent>
    </TransformWrapper>
  );
};
